import React from 'react';

const PaymentSuccessFinal = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
    <div className="bg-white p-8 rounded shadow-md text-center">
      <h1 className="text-2xl font-bold text-green-600 mb-4">Payment Complete!</h1>
      <p className="text-gray-700 mb-4">Your payment was successful and your credits have been added to your account.</p>
      <a href="/home" className="text-blue-600 hover:underline">Go to Dashboard</a>
    </div>
  </div>
);

export default PaymentSuccessFinal; 
